import { render, staticRenderFns } from "./DashIcon.vue?vue&type=template&id=ec4beb44&"
import script from "./DashIcon.vue?vue&type=script&lang=js&"
export * from "./DashIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports